import _ from "../../../../@lodash";
import { formatISO } from 'date-fns';

const ReviewModel = (data) =>
  _.defaults(data || {}, {
    // course: "",
    // lesson: "",
    lessons: [],
    start: formatISO(new Date(), { fractionDigits: 6 }),
    end: formatISO(new Date(), { fractionDigits: 6 }),
    cycle: 'dev_alpha',
    pmt_id: "",
    internality: true,
  });

export default ReviewModel;